import React from 'react';
import BrandGlyph from './BrandGlyph';

interface LoadingSpinnerProps {
  size?: number;
  text?: string;
  subtitle?: string;
  className?: string;
  fullHeight?: boolean;
  showProgress?: boolean;
  progress?: number;
}



const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 40,
  text = "Loading...",
  subtitle = "Please wait while we process your request...",
  className = "",
  fullHeight = false,
  showProgress = false,
  progress = 0
}) => {
  return (
    <div className={`loading-state ${fullHeight ? 'loading-full-height' : ''} ${className}`}>
      <div className="loading-content">
        {/* Premium CSS Spinner */}
        <div
          className="premium-spinner"
          style={{
            width: size,
            height: size,
            '--spinner-size': `${size}px`
          } as React.CSSProperties}
        >
          <div className="spinner-ring"></div>
          <div className="spinner-ring-inner"></div>
        </div>

        {text && <h3 className="loading-title gradient-text">{text}</h3>}
        {subtitle && <p className="loading-subtitle">{subtitle}</p>}

        {showProgress && (
          <div className="loading-progress-container">
            <div className="progress-bar-track">
              <div
                className="progress-bar-fill"
                style={{ width: `${Math.min(progress, 100)}%` }}
              />
            </div>
            <span className="progress-value">{Math.round(progress)}%</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default LoadingSpinner;